<form name="form" class="needs-validation" #f="ngForm" novalidate>
    <fieldset [disabled]="readonly">
        <div class="row brd-b">
            <div *ngIf="!readonly" class="col-md-4 brd-r">
                <div class="row">
                    <div class="col-md-12 mb-3 mb-3">
                        <label for="documentTypeId">Type of document </label>
                        <select name="documentTypeId" type="number" class="form-select form-select-sm"
                            [(ngModel)]="fileDetails.documentTypeId" #documentTypeId="ngModel"
                            (change)="setCMDocTypes()"
                            [ngClass]="{ 'is-invalid': documentTypeId.invalid && (documentTypeId.dirty || f.submitted) }"
                            required>
                            <option [ngValue]="null">Select</option>
                            <option *ngFor="let type of getdistinctDocTypes" [ngValue]="type.docTypeId"
                                title="{{type.docTypeDisplayText +' '+ (type.isMandatory || type.mandatoryType > 0 ?'*':'')}}">
                                {{ getDataTrim(type,50) }}

                            </option>
                        </select>
                        <div *ngIf="documentTypeId.invalid" class="invalid-feedback">
                            <div *ngIf="documentTypeId.errors.required">Document type is required</div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-3 mb-3">
                        <label for="documentNameId">CM9 document name</label>

                        <select name="documentNameId" type="number" class="form-select form-select-sm"
                            [(ngModel)]="fileDetails.documentNameId" #documentName="ngModel"
                            (change)="setCMDocInstruction()"
                            [ngClass]="{ 'is-invalid': documentName.invalid && (documentName.dirty || f.submitted) }"
                            required>
                            <option [ngValue]="null">Select</option>
                            <option *ngFor="let type of documentTypes" [ngValue]="type.docNameId">
                                {{replaceGPNwithCode(type.docNameDisplayText) +' '+ (type.isMandatory ?'*':'')}}
                            </option>
                        </select>
                        <div *ngIf="documentName.invalid" class="invalid-feedback">
                            <div *ngIf="documentName.errors.required">Document name is required</div>
                        </div>
                    </div>

                    <div class="col-md-12 mb-3 mb-3">
                        <label>Description</label>
                        <!-- [pattern]="docnamePattern" required -->
                        <input name="description" type="text" [(ngModel)]="fileDetails.description"
                            class="form-control form-control-sm" #description="ngModel"
                            [ngClass]="{ 'is-invalid':description.invalid && (description.dirty ||  f.submitted) }"
                            maxlength="100">
                        <!-- documentName.touched || -->
                        <div *ngIf="description.invalid" class="invalid-feedback">
                            <div *ngIf="description.errors.required">Description is required</div>
                            <div *ngIf="fileDetails.description && description.invalid">
                                Enter valid description
                            </div>
                        </div>
                    </div>
                    <!-- <div *ngIf="docInstruction" class="col-md-12 mb-3">
                        <label>Document upload instruction</label>
                        <p><span class="doc-instruction" role="textbox" contenteditable>{{docInstruction}}</span></p>
                    </div> -->
                    <div class="col-md-12 mb-3 mb-3">
                        <label>Upload file</label>
                        <div class="input-group mb-3">
                            <input [disabled]="disableUpload" #fileControl name="fileName" type="file"
                                (change)="fileSelected($event.target.files)" #fileName
                                [accept]="fileBrowserAllowedTypes" style="display: none;">

                            <input #fileField type="text" class="form-control form-control-sm readonly-date" readonly
                                [value]="selectedFileName"
                                [ngClass]="{ 'is-invalid': (fileName.dirty || fileName.touched || f.submitted) && !selectedDocument && !editMode || ifDocNotValid }"
                                required />

                            <div class="input-group-append">
                                <button [disabled]="disableUpload" type="button" (click)="browseFile()"
                                    class="btn-outline-primary">
                                    Browse
                                </button>
                            </div>
                            <div class="invalid-feedback">
                                <!-- <span *ngIf="ifDocNotValid">
                    File size greater than 10Mb is not allowed
                </span> -->
                                <span *ngIf="f.submitted && !selectedDocument && !editMode">
                                    File is required
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mb-3 text-center mb-3">
                        <button *ngIf="!disableUpload" type="button" (click)="clear(f)"
                            class="btn btn-outline-primary me-2">
                            Clear
                        </button>
                        <button [disabled]="disableUpload" (click)=" uploadDoc(f)" class="btn btn-secondary">
                            <span *ngIf="!disableUpload">Upload</span>
                            <span *ngIf="disableUpload" class="spinner m-3"></span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-8">

                <h6 class="dochead"><strong>Uploaded files</strong></h6>
                <div *ngIf="cicpavisa">
                    <a class="btndownall cursor" style="color: #336699;"
                        href="http://www.cicpa.ae/en/CNIAServices/SecurityPermits.aspx" target="_blank">
                        Download CICPA form
                    </a>
                    <div class="ax_default">
                        <img *ngIf="!showSpinner" class="down_img" src="design/images/download.png"
                            style="padding-left: 10px">
                        <span *ngIf="showSpinner" class="spinner m-3 down_img doc-spin"></span>
                    </div>
                </div>
                <div *ngIf="isEmiratesID">
                    <a eosDebounce class="btndownall cursor" style="color: #336699;"
                        (debounceClick)="downloadEmiratesID()">
                        Download Emirates ID form
                    </a>
                    <div class="ax_default">
                        <img *ngIf="!showSpinner" class="down_img" src="design/images/download.png"
                            style="padding-left: 10px">
                        <span *ngIf="showSpinner" class="spinner m-3 down_img doc-spin"></span>
                    </div>
                </div>
                <a class="btndownall cursor" style="color: #336699;" (click)="multipleDocsShare()">
                    Share documents
                </a>
                <div class="btnshareall">
                    <img class="down_img" src="design/images/share-all.png">
                </div>
                <a eosDebounce class="btndownall cursor" style="color: #336699;" (debounceClick)="downloadAll()">
                    {{ docType }}
                </a>

                <div class="ax_default">
                    <img *ngIf="!showSpinner" class="down_img" src="design/images/download.png">
                    <span *ngIf="showSpinner" class="spinner m-3 down_img doc-spin"></span>
                </div>
                <div class="table-resp table-responsive document-view-scroll mb-3">
                    <table class="table table-sm table-bordered">
                        <tr class="stick-on-top">
                            <th>Type of document</th>
                            <th>CM9 document name</th>
                            <th>Description</th>
                            <th width="120px">Date of upload</th>
                            <th width="140px">Attachment</th>
                            <th>Attachment type</th>
                            <th *ngIf="!readonly" width="60px">Edit</th>
                            <th *ngIf="!readonly" width="60px">Delete</th>
                        </tr>
                        <tr *ngFor="let doc of uploadedFiles">
                            <td>{{doc.documentType.displayText}}</td>

                            <td>
                                {{ doc.documentName | cmNineDocName: model.docPrefix}}
                            </td>
                            <td>{{doc.description}}</td>
                            <td *ngIf="doc.modifiedDate == null">{{doc.createdDate | localDate: 'dd-MM-yyyy'}}</td>
                            <td *ngIf="doc.modifiedDate != null">{{doc.modifiedDate | localDate: 'dd-MM-yyyy'}}</td>
                            <td>
                                <a (click)="downloadDocument(doc)" ngbTooltip="Download">
                                    <img class="cursor" src="design/images/file-attach.png" />
                                </a>
                                <a (click)="preview(doc)" ngbTooltip="Preview">
                                    <img class="ms-2 cursor" src="design/images/show.png" />
                                </a>
                                <a (click)="share(doc)" ngbTooltip="Share">
                                    <img class="ms-2 cursor" src="design/images/share-2.png" />
                                </a>
                            </td>
                            <td>{{ doc.fileName.slice((doc.fileName.lastIndexOf(".") + 1)) }}</td>

                            <td *ngIf="!readonly">
                                <a *ngIf="!doc.synced" (click)="edit(doc, f)" ngbTooltip="Edit">
                                    <img class="cursor" src="design/images/file-edit.png" />
                                </a>
                            </td>

                            <td *ngIf="!readonly">

                                <a *ngIf="doc.synced" (click)="unlink(doc)" ngbTooltip="Cancel">
                                    <img class="cursor" src="design/images/cancel.png" />
                                </a>
                                <a *ngIf="!doc.synced" (click)="delete(doc)" ngbTooltip="Delete">
                                    <img class="cursor" src="design/images/delete.png" />
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </fieldset>
</form>